/**
 * Visitor-friendly caption for sharing activities after booking.
 * Distinct tone from producer captions — warm, personal, peer-to-peer.
 */

import { format } from 'date-fns';
import { sv } from 'date-fns/locale';
import { getPriceCopy } from '@/lib/events/priceCopy';
import type { ActivityShareTarget } from '../ShareTarget';

function formatDate(iso: string | null | undefined): string | null {
  if (!iso) return null;
  try {
    return format(new Date(iso), "d MMMM 'kl' HH:mm", { locale: sv });
  } catch {
    return null;
  }
}

/**
 * Generate a visitor-oriented caption for an activity.
 * Tone: "I'm going — want to join?"
 */
export function generateVisitorCaption(target: ActivityShareTarget): string {
  const lines: string[] = [];

  // Personal opener
  lines.push(`Jag ska på ${target.title} 🌿`);
  lines.push('');

  // Date
  const dateStr = formatDate(target.startDate);
  if (dateStr) {
    lines.push(`📅 ${dateStr}`);
  } else if (target.timingMode === 'open' || target.timingMode === 'anytime') {
    lines.push('📅 Öppet under säsong');
  }

  // Price
  const price = getPriceCopy({ is_free: target.isFree, price_ore: target.priceOre });
  if (price.primary) lines.push(`💰 ${price.primary}`);

  // Venue
  if (target.venueText) lines.push(`📍 ${target.venueText}`);

  lines.push('');
  lines.push('Någon som vill hänga med? 😊');
  lines.push('Boka via Farmly 👇');

  return lines.join('\n');
}
